import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
`;

export const CommunicationSettings = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

export const SubTitle = styled.span`
	${({ theme }) => theme.typography.headlines.h6}
	display: block;
`;
